var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedCircled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#8EDAEA",
    cx: 15,
    cy: 15,
    r: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5852877 11.5381899l-8.5855705 9.0258317c-.5529498.5813045-1.4481345.5813045-1.9996701 0l-3.58639542-3.7688162c-.55153557-.5813046-.55153557-1.5223937 0-2.1036982.55294978-.5798179 1.44813445-.5798179 1.99967002 0l2.5865605 2.7191971 7.5857354-7.97472586c.5515356-.58130459 1.4467203-.58130459 1.9996701 0 .5529497.57981786.5529497 1.52090686 0 2.10221146",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedCircled);
export default __webpack_public_path__ + "static/media/checked-circled.5a3d1569a0f811f81f384eddde87c0d2.svg";
export { ForwardRef as ReactComponent };